import env from './env';

export const BASE_URL = env.urls.baseUrl;